export default __webpack_public_path__ + "static/media/undraw_add_notes.808acf9b.svg";